<template>
  <div class="PaB-form-input" :class="{'has-error': hasError, 'has-value': hasValue}">
    <slot></slot>
    <label>{{label}}</label>

    <p class="PaB-error" v-if="hasError">{{ errorMsg }}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    hasValue: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.PaB-form-input {
  position: relative;
  margin-bottom: 30px;

  input {
    display: block;
    padding: 15px 10px 0 10px !important;
    font-size: 16px !important;
    width: 100%;
    height: 44px;
    color: inherit;
    background-color: transparent;
    border: 1px solid rgba(#7f7f7f, 0.5);
    background-color: #fff;
    color: #000;
  }
  label {
    position: absolute;
    top: 50%;
    left: 10px;
    font-size: 16px;
    transition: all 0.2s linear;
    color: rgba(#7f7f7f, 0.6);
    font-weight: normal;
    pointer-events: none;
    transform: translateY(-50%);
  }
  input:focus ~,
  &.has-value {
    label {
      top: 5px;
      transform: translateY(0);
      font-size: 10px;
    }
  }
  &.has-error {
    input {
      border-color: #d21313;
    }
  }
  .PaB-error {
    color: #d21313;
    position: absolute;
    bottom: -15px;
    font-size: 12px;
    margin: 0;
  }
}
</style>
